module.exports = require("./hsb.js");